import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { BookOpen, User, Users, ShieldAlert } from "lucide-react";
import ManualContribuyente from "../components/manual/ManualContribuyente";
import ManualFuncionario from "../components/manual/ManualFuncionario";
import { useAuth } from "../App";

/** Módulo Manuales — Backoffice.
 *  Tab 1: Manual del Contribuyente (mismo contenido que ve el ciudadano)
 *  Tab 2: Manual del Funcionario (operativo interno)
 */
export default function ManualesPage() {
  const { hasPermission } = useAuth();
  const [tab, setTab] = useState("contribuyente");

  if (!hasPermission("manuales.view")) {
    return (
      <div className="p-8 max-w-lg mx-auto text-center" data-testid="manuales-no-access">
        <div className="p-4 rounded-full bg-red-100 text-red-700 inline-flex mb-4">
          <ShieldAlert className="w-8 h-8" />
        </div>
        <h1 className="font-display font-extrabold text-2xl text-red-800 mb-2">Acceso restringido</h1>
        <p className="text-slate-700">Su rol actual no tiene permiso para consultar el módulo <strong>Manuales</strong>. Contacte al Superadmin si necesita acceso.</p>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8 space-y-6" data-testid="manuales-page">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-green-100 text-green-800">
          <BookOpen className="w-6 h-6" />
        </div>
        <div>
          <h1 className="font-display font-bold text-2xl text-green-900">Manuales</h1>
          <p className="text-sm text-green-700/70">Guías paso a paso para contribuyentes y funcionarios</p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-green-50 border border-green-100">
          <TabsTrigger value="contribuyente" data-testid="tab-manual-contribuyente">
            <User className="w-4 h-4 mr-2" /> Contribuyente
          </TabsTrigger>
          <TabsTrigger value="funcionario" data-testid="tab-manual-funcionario">
            <Users className="w-4 h-4 mr-2" /> Funcionario
          </TabsTrigger>
        </TabsList>
        <TabsContent value="contribuyente" className="mt-4">
          <ManualContribuyente />
        </TabsContent>
        <TabsContent value="funcionario" className="mt-4">
          <ManualFuncionario />
        </TabsContent>
      </Tabs>
    </div>
  );
}
